// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"63697c31","254":"bee59d09","432":"6e847c31","630":"2a78cb6d","775":"05f67b76"}[chunkId] + ".chunk.css";
};